<template>
  <b-modal
    id="eventPageDeniedModal"
    centered
    size="md"
    modal-class="deniedModal"
    @hidden="$emit('hidePopup')"
    title="不符合購買身份"
    okOnly
    header-class="deniedModal__header st_color_main_light pb-3 border-0"
    body-class="deniedModal__body pt-0"
    footer-class="deniedModal__footer border-0">
    <div class="deniedModal__content st_color_gray_darker">
      你選擇了不符合購買身份的票種，請您檢查勾選的票種後再繼續進行下一步活動報名！
    </div>

    <template slot="modal-ok">
      <div class="st_main_l deniedModal__footer__button d-block w-100">
        確定
      </div>
    </template>
  </b-modal>
</template>
<script>
  export default {
    mounted () {
      this.$root.$emit('bv::show::modal', 'eventPageDeniedModal')
    },
  }
</script>

<style lang="scss">
  .deniedModal {
    .modal-content {
      border-color: $st_color_gray_light;
    }

    &__header {
      .modal-title {
        margin-top: 5px;
        font-size: 18px;
        line-height: 26px;

        @include media-breakpoint-up(md) {
          font-size: 21px;
          line-height: 30px;
        }
      }

      .close {
        font-size: 30px;
        line-height: 19px;

        @include media-breakpoint-up(md) {
          font-size: 23px;
          line-height: 14px;
        }
      }
    }

    &__footer {
      .btn-primary {
        padding: 0;
        background-color: transparent;
        border-color: transparent;
        display: block;
        width: 100%;
        max-width: 100px;
      }

      &__button {
        min-width: auto;
      }
    }
  }
</style>
